import { useState } from 'react';

import AuthChoiceScreen from '../components/AuthChoiceScreen';
import SentinelAuth from '../components/SentinelAuth';
import SentinelSignals from '../components/SentinelSignals';

const AuthPage = () => {
  const [entryMode, setEntryMode] = useState('choice'); // "choice", "sentinel", "signals"

  const handleChoiceSelect = choice => {
    setEntryMode(choice);
  };

  const handleBackToChoice = () => {
    setEntryMode('choice');
  };

  if (entryMode === 'choice') {
    return <AuthChoiceScreen onChoiceSelect={handleChoiceSelect} />;
  }

  if (entryMode === 'sentinel') {
    return <SentinelAuth onBack={handleBackToChoice} />;
  }

  if (entryMode === 'signals') {
    return <SentinelSignals onBack={handleBackToChoice} />;
  }

  return null;
};

export default AuthPage;
